import { useEffect, useRef, useState } from 'react'
import { RotatingLines } from 'react-loader-spinner'
import '../../styles/Admin/AdminHome.css'
import axios from 'axios'
import { numericFormatter } from 'react-number-format'
import { toast } from 'react-toastify'
import { Col, Row } from 'react-bootstrap'
import InputText from '../Input/InputText'
import InputNumber from '../Input/InputNumber'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { fa1, fa2, fa3, fa4, faPlus, faTag } from '@fortawesome/free-solid-svg-icons'
import Button from '../Utils/Button'
import { BrowserView } from 'react-device-detect'


function AdminHome() {

    const [isLoading, setIsLoading] = useState(true)
    const [counters, setCounters] = useState(null)
    const counter1LabelRef = useRef()
    const [counter1Label, setCounter1Label] = useState("")
    const [counter1LabelError, setCounter1LabelError] = useState(null)
    const counter1Ref = useRef()
    const [counter1, setCounter1] = useState("")
    const [counter1Error, setCounter1Error] = useState(null)
    const counter2LabelRef = useRef()
    const [counter2Label, setCounter2Label] = useState("")
    const [counter2LabelError, setCounter2LabelError] = useState(null)
    const counter2Ref = useRef()
    const [counter2, setCounter2] = useState("")
    const [counter2Error, setCounter2Error] = useState(null)
    const counter3LabelRef = useRef()
    const [counter3Label, setCounter3Label] = useState("")
    const [counter3LabelError, setCounter3LabelError] = useState(null)
    const counter3Ref = useRef()
    const [counter3, setCounter3] = useState("")
    const [counter3Error, setCounter3Error] = useState(null)
    const counter4LabelRef = useRef()
    const [counter4Label, setCounter4Label] = useState("")
    const [counter4LabelError, setCounter4LabelError] = useState(null)
    const counter4Ref = useRef()
    const [counter4, setCounter4] = useState("")
    const [counter4Error, setCounter4Error] = useState(null)

    useEffect(() => {

        getCounter()

    }, [])

    function getCounter() {

        setIsLoading(true)
        axios.get(process.env.REACT_APP_API_URL + 'counter').then((response) => {
            response.data.updatedAt = new Date(response.data.updatedAt).toLocaleDateString("fr-FR", { hour: 'numeric', minute: 'numeric' })
            response.data.counter1 = numericFormatter(response.data.counter1.toString(), { thousandSeparator: " " })
            response.data.counter2 = numericFormatter(response.data.counter2.toString(), { thousandSeparator: " " })
            response.data.counter3 = numericFormatter(response.data.counter3.toString(), { thousandSeparator: " " })
            response.data.counter4 = numericFormatter(response.data.counter4.toString(), { thousandSeparator: " " })
            setCounters(response.data)
            setIsLoading(false)
        }).catch((error) => {
            console.log("error :\n" + JSON.stringify(error) + "\n\n")
            setIsLoading(false)
        })

    }

    function updateCounter() {

        var error = []
        var counter1LabelFormat = counters.counter1Label
        if (counter1Label.length > 0) {
            counter1LabelFormat = counter1Label
        }
        var counter2LabelFormat = counters.counter2Label
        if (counter2Label.length > 0) {
            counter2LabelFormat = counter2Label
        }
        var counter3LabelFormat = counters.counter3Label
        if (counter3Label.length > 0) {
            counter3LabelFormat = counter3Label
        }
        var counter4LabelFormat = counters.counter4Label
        if (counter4Label.length > 0) {
            counter4LabelFormat = counter4Label
        }
        var counter1Format = parseInt(counters.counter1.replace(/\s/g, ''))
        if (counter1.length > 0) {
            counter1Format = parseInt(counter1.replace(/\s/g, ''))
        }
        var counter2Format = parseInt(counters.counter2.replace(/\s/g, ''))
        if (counter2.length > 0) {
            counter2Format = parseInt(counter2.replace(/\s/g, ''))
        }
        var counter3Format = parseInt(counters.counter3.replace(/\s/g, ''))
        if (counter3.length > 0) {
            counter3Format = parseInt(counter3.replace(/\s/g, ''))
        }
        var counter4Format = parseInt(counters.counter4.replace(/\s/g, ''))
        if (counter4.length > 0) {
            counter4Format = parseInt(counter4.replace(/\s/g, ''))
        }
        if (error.length > 0) {
            error.map((item) => toast.error(item))
        } else {
            const toastId = toast.loading("Modification...")
            axios.put(process.env.REACT_APP_API_URL + 'counter/', {
                counter1Label: counter1LabelFormat,
                counter1: counter1Format,
                counter2Label: counter2LabelFormat,
                counter2: counter2Format,
                counter3Label: counter3LabelFormat,
                counter3: counter3Format,
                counter4Label: counter4LabelFormat,
                counter4: counter4Format,
            }).then((response) => {
                if (response.data === "COUNTER_UPDATED") {
                    setCounter1Label("")
                    setCounter1LabelError(null)
                    setCounter1("")
                    setCounter1Error(null)
                    setCounter2Label("")
                    setCounter2LabelError(null)
                    setCounter2("")
                    setCounter2Error(null)
                    setCounter3Label("")
                    setCounter3LabelError(null)
                    setCounter3("")
                    setCounter3Error(null)
                    setCounter4Label("")
                    setCounter4LabelError(null)
                    setCounter4("")
                    setCounter4Error(null)
                    getCounter()
                    toast.update(toastId, { render: "Compteurs mofifiés", type: "success", isLoading: false, autoClose: 5000 })
                }
            }).catch((error) => {
                if (error.response) {
                    console.log("error :\n" + JSON.stringify(error.response.data.message) + "\n\n")
                    var errorMessage = error.response.data.message
                    if (errorMessage === 'ERROR_PARAMS') {
                        errorMessage = "Erreur lors des paramètres transmis"
                    } else if (errorMessage === 'ERROR_COUNTER_NOT_FOUND') {
                        errorMessage = "Le compteurs est introuvable"
                    } else if (errorMessage === 'ERROR_COUNTER_UPDATING') {
                        errorMessage = "Erreur lors de la modification du compteur"
                    }
                    toast.update(toastId, { render: errorMessage, type: "error", isLoading: false, autoClose: 5000 })
                }
            })

        }

    }

    return (

        <>
            <BrowserView>
                <div className='adminHome'>
                    {isLoading ?
                        <div className='loader'>
                            <RotatingLines
                                strokeColor={"#5b7c18"}
                                strokeWidth={"5"}
                                animationDuration={"1"}
                                width={"40"}
                                visible={true}
                            />
                        </div>
                        :
                        counters && (
                            <>
                                <div className='adminTitle'>Compteurs</div>
                                <div className='adminHomeForm'>
                                    <Row>
                                        <Col>
                                            <InputText
                                                type={'upper'}
                                                ref={counter1LabelRef}
                                                text={counter1Label} setText={setCounter1Label}
                                                textError={counter1LabelError} setTextError={setCounter1LabelError}
                                                icon={<FontAwesomeIcon icon={faTag} />}
                                                placeholder={counters?.counter1Label || ''}
                                                maxLength={64}
                                            />
                                        </Col>
                                        <Col>
                                            <InputNumber
                                                ref={counter1Ref}
                                                number={counter1} setNumber={setCounter1}
                                                numberError={counter1Error} setNumberError={setCounter1Error}
                                                icon={<FontAwesomeIcon icon={fa1} />}
                                                placeholder={counters.counter1}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <InputText
                                                type={'upper'}
                                                ref={counter2LabelRef}
                                                text={counter2Label} setText={setCounter2Label}
                                                textError={counter2LabelError} setTextError={setCounter2LabelError}
                                                icon={<FontAwesomeIcon icon={faTag} />}
                                                placeholder={counters.counter2Label}
                                                maxLength={64}
                                            />
                                        </Col>
                                        <Col>
                                            <InputNumber
                                                ref={counter2Ref}
                                                number={counter2} setNumber={setCounter2}
                                                numberError={counter2Error} setNumberError={setCounter2Error}
                                                icon={<FontAwesomeIcon icon={fa2} />}
                                                placeholder={counters.counter2}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <InputText
                                                type={'upper'}
                                                ref={counter3LabelRef}
                                                text={counter3Label} setText={setCounter3Label}
                                                textError={counter3LabelError} setTextError={setCounter3LabelError}
                                                icon={<FontAwesomeIcon icon={faTag} />}
                                                placeholder={counters.counter3Label}
                                                maxLength={64}
                                            />
                                        </Col>
                                        <Col>
                                            <InputNumber
                                                ref={counter3Ref}
                                                number={counter3} setNumber={setCounter3}
                                                numberError={counter3Error} setNumberError={setCounter3Error}
                                                icon={<FontAwesomeIcon icon={fa3} />}
                                                placeholder={counters.counter3}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <InputText
                                                type={'upper'}
                                                ref={counter4LabelRef}
                                                text={counter4Label} setText={setCounter4Label}
                                                textError={counter4LabelError} setTextError={setCounter4LabelError}
                                                icon={<FontAwesomeIcon icon={faTag} />}
                                                placeholder={counters.counter4Label}
                                                maxLength={64}
                                            />
                                        </Col>
                                        <Col>
                                            <InputNumber
                                                ref={counter4Ref}
                                                number={counter4} setNumber={setCounter4}
                                                numberError={counter4Error} setNumberError={setCounter4Error}
                                                icon={<FontAwesomeIcon icon={fa4} />}
                                                placeholder={counters.counter4}
                                            />
                                        </Col>
                                    </Row>
                                </div>
                                <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPlus} className='buttonIcon' />} text={"Modifier"} onClick={() => updateCounter()} />

                            </>
                        )
                    }
                </div>
            </BrowserView>
        </>


    )

}

export default AdminHome
